/*  
 * Tracks the Tipo Appointment Booking widget's final submission (the app  
 * renders client-side with no native events/dataLayer/pixel hooks of its  
 * own — see the MutationObserver pattern already used for Gorgias in  
 * gtm-script.liquid). Publishes a Shopify analytics custom event with the  
 * fields captured from the booking form so a subscribed custom pixel can  
 * forward them to Meta, and fires a Triple Whale custom event with the  
 * same lead data.  
 */
(function() {
  'use strict';
  var INPUT_SELECTORS = {
    first_name: 'input[id^="t-first_name-"]',
    last_name: 'input[id^="t-last_name-"]',
    email: 'input[id^="t-email-"]',
    phone: 'input[id^="phone_number-"]'
  };
  // The app's own template only builds this class list once real booking  
  // details exist to summarize; an error result renders the same panel  
  // shell with an empty content area, so "has rows" is our success signal.  
  var COMPLETED_PANEL_FALLBACK_SELECTOR =
    '[class*="completed-module__completed"]';
  var COMPLETED_ROW_FALLBACK_SELECTOR = '[class*="completed-module__row"]';
  var capturedData = {};
  var trackedInputs = new WeakSet();
  var eventFired = false;

  function matchesSelector(node, selector) {
    return typeof node.matches === 'function' && node.matches(selector);
  }

  function collectMatches(root, selector) {
    var matches = [];
    if (matchesSelector(root, selector)) matches.push(root);
    if (typeof root.querySelectorAll === 'function') {
      root.querySelectorAll(selector).forEach(function(el) {
        matches.push(el);
      });
    }
    return matches;
  }

  function bindCaptureInputs(root) {
    Object.keys(INPUT_SELECTORS).forEach(function(field) {
      collectMatches(root, INPUT_SELECTORS[field]).forEach(function(input) {
        if (trackedInputs.has(input)) return;
        trackedInputs.add(input);
        if (input.value) capturedData[field] = input.value.trim();
        input.addEventListener('input', function() {
          capturedData[field] = input.value.trim();
        });
      });
    });
  }

  function getCompletedPanelSelector() {
    var styles = window.Tipo && window.Tipo.Booking && window.Tipo.Booking.styles &&
      window.Tipo.Booking.styles.completed;
    if (styles && styles.completed) return '.' + CSS.escape(styles.completed);
    return COMPLETED_PANEL_FALLBACK_SELECTOR;
  }

  function getCompletedRowSelector() {
    var styles = window.Tipo && window.Tipo.Booking && window.Tipo.Booking.styles &&
      window.Tipo.Booking.styles.completed;
    if (styles && styles.row) return '.' + CSS.escape(styles.row);
    return COMPLETED_ROW_FALLBACK_SELECTOR;
  }

  function sendTripleWhaleEvent() {
    if (typeof TriplePixel !== 'function') return;
    TriplePixel('custom', 'lead_book_experience', {
      email: capturedData.email || '',
      firstName: capturedData.first_name || '',
      lastName: capturedData.last_name || '',
      phone: capturedData.phone || '',
      pageUrl: window.location.href
    });
  }

  function publishSubmissionEvent() {
    if (eventFired) return;
    if (!capturedData.email && !capturedData.phone) return;
    eventFired = true;
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish('leaf_lead_submitted', {
        userData: {
          customer: {
            phone: capturedData.phone || '',
            email: capturedData.email || '',
            address: {
              first_name: capturedData.first_name || '',
              last_name: capturedData.last_name || ''
            }
          }
        }
      });
      console.log("Finish sending events to Signal")
    }
    sendTripleWhaleEvent();
  }

  function checkForCompletionPanel(root) {
    if (eventFired) return;
    var panels = collectMatches(root, getCompletedPanelSelector());
    if (!panels.length) return;
    var rowSelector = getCompletedRowSelector();
    panels.forEach(function(panel) {
      if (panel.querySelector(rowSelector)) publishSubmissionEvent();
    });
  }

  function init() {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          bindCaptureInputs(node);
          checkForCompletionPanel(node);
        });
      });
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    bindCaptureInputs(document.body);
    checkForCompletionPanel(document.body);
  }
  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();